module.exports = __webpack_public_path__ + "img/member_trading_record_icon_435001.49b1f4c7.png";